import type { RouteRecordRaw } from 'vue-router'

const deviceIotRoutes: RouteRecordRaw[] = [
  {
    path: 'device-iot',
    name: 'device-iot',
    meta: {
      titleKey: 'routes.device-iot.title',
      icon: 'Connection',
      helpKey: 'device_iot'
    },
    redirect: { name: 'device-group' },
    children: [
      {
        path: 'device-group',
        name: 'device-group',
        component: () => import('@/views/device-iot/DeviceGroup.vue'),
        meta: { titleKey: 'routes.device-iot.device-group.title', helpKey: 'device_group' }
      },
      {
        path: 'device-management',
        name: 'device-management',
        component: () => import('@/views/device-iot/DeviceManagement.vue'),
        meta: { titleKey: 'routes.device-iot.device-management.title', helpKey: 'device_management' }
      },
      {
        path: 'device-preferences',
        name: 'device-preferences',
        component: () => import('@/views/device-iot/DevicePreferences.vue'),
        meta: { titleKey: 'routes.device-iot.device-preferences.title', helpKey: 'device_preferences' }
      },
      {
        path: 'user-preferences',
        name: 'user-preferences',
        component: () => import('@/views/device-iot/UserPreferences.vue'),
        meta: { titleKey: 'routes.device-iot.user-preferences.title', helpKey: 'user_preferences' }
      },
      {
        path: 'device-alarm',
        name: 'device-alarm',
        component: () => import('@/views/device-iot/DeviceAlarm.vue'),
        meta: { titleKey: 'routes.device-iot.device-alarm.title', helpKey: 'device_alarm' }
      }
    ]
  }
]

export default deviceIotRoutes
